import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS, tabletCSS } from '@measures/responsive'
import translate from '@i18n'
import SportImage from '@components/BlickPlusOnboardingModal/AppPage/SportImage'
import StoreIcons from '@components/BlickPlusOnboardingModal/AppPage/StoreIcons'
import Text from '@components/BlickPlusOnboardingModal/Text'
import Title from '@components/BlickPlusOnboardingModal/Title'

const StyledWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing32 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing32};
    ${desktopCSS(css`
      display: none;
    `)}

    ${tabletCSS(css`
      display: none;
    `)}
  `}
`

const StyledHeadline = styled.div`
  ${({
    theme: {
      spacing: { spacing12 },
    },
  }) => css`
    display: flex;
    flex-direction: column;
    gap: ${spacing12};
  `}
`

const StyledSportWrapper = styled.div`
  ${({
    theme: {
      spacing: { spacing16, spacing8 },
    },
  }) => css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing16};
    margin-bottom: ${spacing8};
  `}
`

const StyledText = styled(Text)`
  font-weight: 700;
`

const AppPageMobile: FunctionComponent = () => (
  <StyledWrapper>
    <StyledHeadline>
      <Title>
        {translate('blickPlusOnboardingModal.appPage.title.mobile')}
      </Title>
      <Text>
        {translate('blickPlusOnboardingModal.appPage.textPart1.mobile')}
      </Text>
      <Text>
        {translate('blickPlusOnboardingModal.appPage.textPart2.mobile')}
      </Text>
      <StoreIcons />
    </StyledHeadline>
    <StyledSportWrapper>
      <SportImage />
      <Text>
        <StyledText>
          {translate('blickPlusOnboardingModal.appPage.sportQuestion')}
        </StyledText>
        {translate('blickPlusOnboardingModal.appPage.sportText.mobile')}
      </Text>
    </StyledSportWrapper>
  </StyledWrapper>
)

export default AppPageMobile
